<template>
    <div class="app" id="app">
        <mode-switcher
            :backButtonBehaviors="backButtonBehaviors"
            :currentBackButtonBehavior="currentBackButtonBehavior"
            :onChangeBackButtonBehavior="changeBackButtonBehavior"

            :currentMode="currentMode"
            :availableModes="availableModes"
            :onChangeMode="changeMode"

            :switcherLayouts="switcherLayouts"
            :currentSwitcherLayout="currentSwitcherLayout"
            :onChangeSwitcherLayout="changeSwitcherLayout"

            :currentShowAllBehavior="currentShowAllBehavior"
            :showAllBehaviors="showAllBehaviors"
            :onChangeShowAllBehavior="changeShowAllBehavior"

            :currentAltClickMode="currentAltClickMode"
            :altClickModes="altClickModes"
            :onChangeAltClickMode="changeAltClickMode"
        />
        <app-context-switcher
            :appHistory="appSwitcherItems"
            :show="showAppSwitcher"
            :tools="tools"
            v-if="currentSwitcherLayout === 'boxes'"
        />
        <div class="app-vignette" v-if="currentApp.dropdown" @click="closeDropdown" />
        <header class="app-header">
            <app-breadcrumbs
                :data="breadcrumbsWithDropdown"
                :currentApp="currentApp"
                :updateBreadcrumbs="updateBreadcrumbs"
                :toggleDropdown="toggleDropdown"
                :dropdownVisible="currentApp.dropdown"
                :tools="tools"
                :showBreadcrumbs="currentSwitcherLayout === 'boxes'"
                :showAppSwitcher="showAppSwitcher"
            />
            <app-tabs
                v-if="currentSwitcherLayout === 'tabs'"
                :appHistory="currentApp.appStateHistory"
                :tools="tools"
            />
            <section class="app-header__end">
                <div class="app-header__divider"></div>
                <section class="app-switcher">
                    <app-icon-button
                        v-for="(route, key) in routes"
                        :class="['app-switcher__button', currentRouteKey === key ? 'selected' : null]"
                        :key="key"
                        :disabled="!route.appState"
                        :prototype="route"
                        @click="() => {
                            if (!route.appState) {
                                return null;
                            }
                            return changeRoute(key);
                        }"
                    />
                    <app-icon-button
                        :class="['app-switcher__button', 'app-switcher__button--popover']"
                        :prototype="{
                            icon: require('./assets/icons/icon-chevron-down.svg')
                        }"
                    />
                </section>
                <div class="app-header__divider"></div>
                <section class="app-switcher">
                    <app-icon-button
                        :class="['app-switcher__button', 'app-switcher__button--popover']"
                        :prototype="{
                            icon: require('./assets/icons/icon-bookmark.svg')
                        }"
                    />
                    <app-icon-button
                        :class="['app-switcher__button', 'app-switcher__button--popover']"
                        :prototype="{
                            icon: require('./assets/icons/icon-notifications.svg')
                        }"
                    />
                    <app-icon-button
                        :class="['app-switcher__button', 'app-switcher__button--popover']"
                        :prototype="{
                            icon: require('./assets/icons/icon-folder.svg')
                        }"
                    />
                    <app-icon-button
                        :class="['app-switcher__button', 'app-switcher__button--popover']"
                        :prototype="{
                            icon: require('./assets/icons/icon-chevron-down.svg')
                        }"
                    />
                </section>
                <div class="app-header__divider"></div>
                <app-icon-button
                    :class="['app-switcher__button']"
                    :prototype="{
                        icon: require('./assets/profile-picture.png')
                    }"
                />
            </section>
        </header>
        <view-container
            :tools="tools"
        />
        <app-toasts
            :toasts="toasts"
            :tools="tools"
        />
    </div>
</template>

<script>
    import Vue from 'vue';
    import ViewContainer from './components/ViewContainer';
    import Breadcrumbs from './components/Breadcrumbs';
    import AppSwitcher from './components/AppSwitcher';
    import generator from './helpers/generator';
    import keymaster from 'keymaster';
    import AppToast from './components/app/AppToast';
    import ModeSwitcher from './components/ModeSwitcher';
    import AppTabs from './components/app/AppTabs';
    import config from '../config';
    const assetsPublicPath = process.env.NODE_ENV === 'production' ? config.build.assetsPublicPath : config.dev.assetsPublicPath;

    export default {
        name: 'app',
        mounted() {
            // Add initial app state to app state history
            this.addInitialAppStateToHistory();

            console.groupCollapsed('App loaded');
                console.log('This:', this);
                console.log('Current App:', this.currentApp);
                console.log('Tools:', this.tools);
                console.log('Mode:', this.currentMode);
            console.groupEnd();
        },
        components: {
            ViewContainer,
            'app-breadcrumbs': Breadcrumbs,
            'app-context-switcher': AppSwitcher,
            'app-toasts': AppToast,
            ModeSwitcher,
            AppTabs,
        },
        data: () => {
            return {
                transitionId: null,
                showAppSwitcher: false,
                showDebugger: false,
                hideBackButton: true,
                toasts: [

                ],
                currentShowAllBehavior: 'full_list',
                showAllBehaviors: [
                    {
                        key: 'full_list',
                        label: 'Full list',
                        image: false,
                    },
                    {
                        key: 'owner_home',
                        label: 'Home with search',
                        image: false,
                    },
                ],
                currentSwitcherLayout: 'boxes',
                switcherLayouts: [
                    {
                        key: 'boxes',
                        label: 'Boxes',
                        image: false,
                    },
                    {
                        key: 'tabs',
                        label: 'Tabs',
                        image: false,
                    },
                ],
                currentBackButtonBehavior: 'show_back',
                backButtonBehaviors: [
                    {
                        key: 'show_back',
                        label: 'Back',
                        image: assetsPublicPath + 'static/images/close-icon.svg',
                    },
                    {
                        key: 'show_close',
                        label: 'Close',
                        image: assetsPublicPath + 'static/images/back-icon.svg',
                    },
                    {
                        key: 'dont_show',
                        label: 'No button',
                        image: false,
                    },
                ],
                currentAltClickMode: '',
                altClickModes: [
                    {
                        key: '',
                        label: 'Nothing',
                        image: false,
                    },
                    {
                        key: 'OWNER_APP_CLEAR',
                        label: 'Mode A',
                        image: false,
                    },
                    {
                        key: 'SAME_APP_ADD',
                        label: 'Mode B',
                        image: false,
                    },
                    {
                        key: 'OWNER_APP_NEW_CONTEXT',
                        label: 'Mode C',
                        image: false,
                    },
                ],

                currentMode: 'OWNER_APP_CLEAR',
                availableModes: [
                    {
                        key: 'OWNER_APP_CLEAR',
                        label: 'A. Clear breadcrumbs and add (owner app)',
                        description: '',
                        image: assetsPublicPath + 'static/images/mode-4.svg',
                    },
                    {
                        key: 'SAME_APP_ADD',
                        label: 'B. Add to breadcrumbs (same app)',
                        description: '',
                        image: assetsPublicPath + 'static/images/mode-1.svg',
                    },
                    // 2
                    // {
                    //     key: 'OWNER_APP_ADD',
                    //     label: 'B. Add to breadcrumbs (owner app)',
                    //     description: '',
                    //     image: assetsPublicPath + 'static/images/mode-2.svg',
                    // },
                    // 3
                    {
                        key: 'OWNER_APP_NEW_CONTEXT',
                        label: 'C. Add new context (owner app)',
                        description: '',
                        image: assetsPublicPath + 'static/images/mode-3.svg',
                    },
                    // 4

                    // 5
                    // {
                    //     key: 'MODIFIER_1',
                    //     label: 'E. Option A on normal click / Option C when holding ALT',
                    //     description: '',
                    //     image: assetsPublicPath + 'static/images/mode-5.svg',
                    // },
                    // // 6
                    // {
                    //     key: 'MODIFIER_2',
                    //     label: 'F. Option A on normal click / Option D when holding ALT',
                    //     description: '',
                    //     image: assetsPublicPath + 'static/images/mode-6.svg',
                    // },
                ],
                currentRouteKey: 'users',
                routes: {
                    users: {
                        key: 'user',
                        dropdown: false,
                        panes: {
                            search: false,
                            preview: false,
                        },
                        icon: require('./assets/icons/app-icon-users.png'),
                        name: 'Users',
                        appState: [
                            {
                                title: 'Home',
                                key: 'users-view',
                                owner: 'users',
                                data: {
                                    pane: generator.randomContentOfType('user'),
                                },
                            },
                        ],
                        appStateHistory: [],
                        stackId: () => this.randomId(),
                    },
                    packages: {
                        key: 'package',
                        dropdown: false,
                        panes: {
                            search: false,
                            preview: false,
                        },
                        icon: require('./assets/icons/app-icon-packages.png'),
                        name: 'Packages',
                        appState: [
                            {
                                title: 'Home',
                                key: 'packages-view',
                                owner: 'packages',
                                data: {
                                    pane: generator.randomContentOfType('package'),
                                },
                            },
                        ],
                        appStateHistory: [],
                        stackId: () => this.randomId(),
                    },
                    orders: {
                        key: 'order',
                        dropdown: false,
                        panes: {
                            search: false,
                            preview: false,
                        },
                        icon: require('./assets/icons/app-icon-orders.png'),
                        name: 'Orders',
                        appState: [
                            {
                                title: 'Home',
                                key: 'orders-view',
                                owner: 'orders',
                                data: {
                                    pane: generator.randomContentOfType('order'),
                                },
                            },
                        ],
                        appStateHistory: [],
                        stackId: null,
                    },
                    instances: {
                        key: 'instance',
                        dropdown: false,
                        panes: {
                            search: false,
                            preview: false,
                        },
                        icon: require('./assets/icons/app-icon-bibs.png'),
                        name: 'Instances',
                        appState: [
                            {
                                title: 'Home',
                                key: 'instances-view',
                                owner: 'instances',
                                data: {
                                    pane: generator.randomContentOfType('instance'),
                                },
                            },
                        ],
                        appStateHistory: [],
                        stackId: () => this.randomId(),
                    },
                    items: {
                        key: 'item',
                        dropdown: false,
                        panes: {
                            search: false,
                            preview: false,
                        },
                        icon: require('./assets/icons/app-icon-items.png'),
                        name: 'Items',
                        appState: [
                            {
                                title: 'Home',
                                key: 'items-view',
                                owner: 'items',
                                data: {
                                    pane: generator.randomContentOfType('item'),
                                },
                            },
                        ],
                        appStateHistory: [],
                        stackId: () => this.randomId(),
                    },
                    // finances: {
                    //     icon: require('./assets/icons/app-icon-finances.png'),
                    //     name: 'Finances',
                    // },
                    // users: {
                    //     icon: require('./assets/icons/app-icon-users.png'),
                    //     name: 'Users',
                    // },
                    // contacts: {
                    //     icon: require('./assets/icons/app-icon-contacts.png'),
                    //     name: 'Contacts',
                    // },
                    // checkout: {
                    //     icon: require('./assets/icons/app-icon-checkout.png'),
                    //     name: 'Checkout',
                    // },
                },
            };
        },
        computed: {
            appSwitcherItems() {
                const { currentApp } = this;
                return currentApp.appStateHistory;
            },

            showContextSwitcherButton() {
                return  this.tools.modifiers.currentMode === 'OWNER_APP_NEW_CONTEXT' ||
                        this.tools.modifiers.currentMode === 'MODIFIER_1';
            },
            breadcrumbs() {
                const { currentRouteKey, routes } = this;
                const route = routes[currentRouteKey];
                let breadcrumbs = [
                    ...route.appState,
                ];
                return breadcrumbs
            },
            breadcrumbsWithDropdown() {
                const { breadcrumbs } = this;
                const MAX_ITEMS = 6;
                const BEGIN_DROPDOWN_AFTER = 2;
                const count = breadcrumbs.length;
                const breadcrumbsWithIndexes = breadcrumbs.map((b, i) => Object.assign(b, { i }));

                // No dropdown
                if (count <= MAX_ITEMS) {
                    return breadcrumbsWithIndexes;
                }

                const spliced = breadcrumbsWithIndexes.splice(BEGIN_DROPDOWN_AFTER - 1, breadcrumbs.length - (2));
                breadcrumbsWithIndexes.splice(BEGIN_DROPDOWN_AFTER - 1, 0, spliced);

                return breadcrumbsWithIndexes;
            },
            currentApp: {
                get() {
                    return this.routes[this.currentRouteKey];
                },
                set(newValue) {
                    Vue.set(this.routes, this.currentRouteKey, newValue)
                },
            },
            currentView: {
                get() {
                    const appState = this.currentApp.appState;
                    return appState[appState.length - 1];
                },
            },

            // Get app icons
            appIcons() {
                const routes = this.routes;
                return Object.keys(routes).reduce((a, b) => {
                    return Object.assign(a, { [routes[b].key]: routes[b].icon });
                }, {});
            },

            // Handy tools that can be passed down into components
            tools() {
                const { currentShowAllBehavior, transitionId, presetToKey, currentBackButtonBehavior, toggleContextSwitcher, switchContext, replaceAppState, closePreviewPane, togglePane, currentApp, appIcons, changeRoute, changeView, goBack, currentView, currentRouteKey, updateCurrentViewData, replaceCurrentViewData, currentMode, hideBackButton, routes } = this;
                return {
                    transitionId,
                    currentApp,
                    currentRouteKey,
                    currentPaneKey: (this.currentView.data && this.currentView.data.pane) ? this.currentView.data.pane.type : false,
                    navigate: {
                            changeRoute,
                            changeView,
                            goBack,
                    },
                    helpers: {
                        presetToKey,
                    },
                    actions: {
                        togglePane,
                        closePreviewPane,
                        replaceAppState,
                        switchContext,
                        toggleContextSwitcher,
                    },
                    modifiers: {
                        hideBackButton,
                        currentMode,
                        currentBackButtonBehavior,
                        currentShowAllBehavior,
                    },
                    currentView,
                    changeView,
                    randomizer: new Chance(),
                    generator,
                    updateCurrentViewData,
                    replaceCurrentViewData,
                    routes,
                    appIcons,
                };
            },
        },
        methods: {
            presetToKey(preset) {
                const routes = this.routes;
                const presetToKeyIndex = Object.keys(routes).reduce((a, b) => {
                    return Object.assign(a, { [routes[b].key]: b});
                }, {});

                if (typeof presetToKeyIndex !== 'undefined') {
                    return presetToKeyIndex[preset];
                } else {
                    console.warn('No key was found with preset: ', preset);
                }
                return null;
            },

            changeMode(mode) {
                this.currentMode = mode;
            },

            changeBackButtonBehavior(val) {
                this.currentBackButtonBehavior = val;
            },

            changeSwitcherLayout(val) {
                this.currentSwitcherLayout = val;
            },

            changeShowAllBehavior(val) {
                this.currentShowAllBehavior = val;
            },

            changeAltClickMode(val) {
                this.currentAltClickMode = val;
            },

            addToast(data = {}) {
                this.toasts = [data];
            },

            togglePane(key, state) {
                Vue.set(this.currentApp.panes, key, (typeof state === 'boolean') ? state : (typeof this.currentApp.panes[key] === 'undefined') ? false : !this.currentApp.panes[key])
            },

            replaceAppState(newAppState) {
                this.currentApp.appState = newAppState;
            },

            switchContext(data) {
                const { appStateHistory } = this.currentApp;
                this.transitionId = this.randomId();

                // Current app (before switch)
                const currentApp = { ...this.currentApp };

                // On switch context we don't have an old stack id
                Vue.set(this.currentApp, 'oldStackId', null);

                // Update the current stack ID
                Vue.set(this.currentApp, 'stackId', data.stackId);

                // We need to save the current app state stack in history (not the clicked/requested one)
                // before replacing with the one the user clicked on
                // Note: It should always be found in the history
                // so it's only a formality that we check for it
                const currentAppHistoryIndex = appStateHistory.findIndex(i => i.stackId === currentApp.stackId);
                if (currentAppHistoryIndex >= 0) {
                    Vue.set(this.currentApp.appStateHistory, currentAppHistoryIndex, {
                        // ...this.currentApp.appStateHistory[currentAppHistoryIndex],
                        stackId: currentApp.stackId,
                        stack: currentApp.appState,
                    });
                } else {
                    console.error('Whoops! The stack ID of ' + currentApp.stackId + ' was not found in current app state history (which it should!)');
                }

                // Now we replace the app state with the selected stack
                // And set the stackId
                this.replaceAppState(data.stack);

                this.showAppSwitcher = false;
            },

            // Adds initial app state to history
            // so that the app switcher has at least one item
            addInitialAppStateToHistory() {
                Object.keys(this.routes).forEach(key => {
                    const randomId = this.randomId();
                    const route = this.routes[key];
                    Vue.set(route, 'stackId', randomId);
                    Vue.set(route, 'appStateHistory', [{
                        stack: route.appState,
                        stackId: randomId,
                    }]);
                });
            },

            toggleContextSwitcher(state) {
                this.showAppSwitcher = (typeof state === 'boolean') ? state : !this.showAppSwitcher;
            },

            closePreviewPane() {
                this.updateCurrentViewData({
                    pane: false,
                });
                this.togglePane('preview', false);
            },

            // Change route (app)
            changeRoute(key, toast = false) {
                this.toggleContextSwitcher(false);
                this.currentApp.dropdown = false;
                this.currentRouteKey = key;
                const app = this.routes[key];

                if (toast && app) {
                    this.addToast({
                        title: app.name,
                        icon: app.key,
                    });
                }
            },


            // Push to app state
            pushToAppState(Data, root = false) {
                const stateId = this.randomId();
                const data = { ...Data, stateId, };
                const appState = this.currentApp.appState;
                const appStateLength = appState.length;
                // If root is set to true we replace the app state
                // just before the first item (which is home)
                if (root) {
                    this.currentApp.appState = [appState[0]];
                    this.currentApp.appState.push(data);
                } else {
                    this.currentApp.appState.push(data);
                }
            },

            // Check if context switch is allowed
            shouldUpdateContext(currentView, nextView) {
                // Don't do context switch within the users app
                if (nextView.owner === 'users' && currentView.owner === nextView.owner) {
                    return false;
                }

                return true;
            },

            // Change view (inside app)
            changeView(data, callback, root = false) {
                const { currentAltClickMode, shouldUpdateContext } = this;
                let currentMode = this.currentMode;
                this.closeDropdown();

                /**
                 * In some circumstances we don't want to allow context switch
                 * e.g. the users app (when viewing fees, loans etc.)
                 */

                    const contextSwitchAllowed = shouldUpdateContext(this.currentView, data);

                /**
                 * If alt-key is pressed
                 * we change the behavior here
                 */

                    if (keymaster.isPressed(18) && currentAltClickMode) {
                        currentMode = currentAltClickMode;
                    }

                /**
                 * Modes
                 */

                    switch (currentMode) {
                        // Mode A
                        case 'OWNER_APP_CLEAR':
                            if (contextSwitchAllowed) {
                                this.changeRoute(data.owner, true);
                                this.clearAppState();
                            }

                            this.pushToAppState(data, root);
                        break;

                        // Mode B
                        case 'SAME_APP_ADD':
                            this.pushToAppState(data, root);
                        break;

                        // Mode C
                        case 'OWNER_APP_NEW_CONTEXT':
                            if (contextSwitchAllowed) {
                                // Change route
                                this.changeRoute(data.owner, true);

                                // Save current context and clear
                                this.addNewContextToCurrentApp([data]);
                            } else {
                                this.pushToAppState(data, root);
                            }

                        break;

                        // case 'OWNER_APP_ADD':
                        //     this.changeRoute(data.owner, true);
                        //     this.pushToAppState(data, root);
                        // break;

                        // case 'MODIFIER_1':
                        //     if (keymaster.isPressed(18)) {
                        //         this.changeRoute(data.owner, true);
                        //         this.addNewContextToCurrentApp([data]);
                        //     } else {
                        //         this.pushToAppState(data, root);
                        //     }
                        // break;
                        //
                        // case 'MODIFIER_2':
                        // if (keymaster.isPressed(18)) {
                        //     this.changeRoute(data.owner, true);
                        //     this.clearAppState();
                        //     this.pushToAppState(data, root);
                        // } else {
                        //     this.pushToAppState(data, root);
                        // }
                        // break;
                    }

                /**
                 * Callback
                 */

                    if (typeof callback === 'function') {
                        callback();
                    }
            },

            // Clear app state (except the first item)
            clearAppState() {
                const { currentApp } = this;
                const currentAppState = [...currentApp.appState];
                currentApp.appState = [currentAppState[0]];
            },

            // New context
            addNewContextToCurrentApp(newAppState) {
                const { currentApp } = this;

                // [HACK ALERT] The change of the transitionId triggers the animation
                // so we can control when to show context switcher animations
                this.transitionId = this.randomId();

                // Clone current app state
                const currentAppState = [...currentApp.appState];

                // Generate new stack ID
                const randomId = this.randomId();

                // Save current app state in app history
                const currentAppHistoryIndex = currentApp.appStateHistory.findIndex(i => i.stackId === currentApp.stackId);
                if (currentAppHistoryIndex >= 0) {
                    Vue.set(currentApp.appStateHistory, currentAppHistoryIndex, {
                        stackId: currentApp.stackId,
                        stack: currentAppState,
                    });
                }

                Vue.set(this.currentApp, 'oldStackId', currentApp.stackId);

                // Add new context to history
                this.currentApp = {
                    ...this.currentApp,
                    stackId: randomId,
                    appStateHistory: [
                        ...currentApp.appStateHistory,
                        {
                            stackId: randomId,
                            stack: newAppState,
                        },
                    ]
                };

                // Make fresh context
                this.currentApp.appState = newAppState;
            },

            // addContextToAppHistory(appState, stackId) {
            //     this.currentApp.appStateHistory.concat([{
            //         stackId,
            //         stack: appState,
            //     }]);
            // },

            // Generate random ID
            randomId() {
                return `${chance.natural()}${chance.syllable()}`;
            },

            // Update breadcrumbs
            updateBreadcrumbs(i) {
                const { appState } = this.currentApp;
                const view = appState[i];
                if (appState.length > 1) {
                    // Slice breadcrumbs
                    const newappState = appState.filter((app, index) => {
                        return index <= i;
                    });

                    this.closeDropdown();
                    this.currentApp.appState = newappState;
                }
            },

            // Update current view
            updateCurrentViewData(data) {
                this.currentView.data = Object.assign(this.currentView.data, data);
            },

            // Replace current view
            replaceCurrentViewData(data) {
                this.currentView.data = data;
            },

            // Go back (one step back in current breadcrumb)
            goBack() {
                if (this.currentApp.appState.length >= 2) {
                    this.currentApp.appState.splice(-1, 1);
                }
            },

            // Console log current app state (useful if we want to make the example with multiple state pr. app)
            consoleLogCurrentAppState() {
                const { currentApp } = this;
                console.log(JSON.stringify(currentApp.appState));
            },

            // Toggle breadcrumb dropdown
            toggleDropdown() {
                this.currentApp.dropdown = !this.currentApp.dropdown;
            },

            // Close breadcrumb dropdown
            closeDropdown() {
                if (this.currentApp) {
                    this.currentApp.dropdown = false;
                }
            }
        },
    };
</script>

<style>
    @import "./styles/all.css";

    .app {
        position: relative;
        z-index: 50;
    }

    .app-state-debugger__content {
        padding: 30px;
        width: 100%;
        overflow: scroll;
        height: 100%;
        background: rgba(0, 0, 0, 0.04);
    }

    .app-state-debugger__toggle {
        position: fixed;
        bottom: 10px;
        z-index: 990;
        left: 10px;
        width: 42px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        background-color: #fff;
        border:2px solid rgba(0,0,0,0.01);
        color: rgba(0,0,0,0.05);
        border-radius: 999px;
        z-index: 999;
    }

    .app-state-debugger {
        box-shadow: 0 3px 40px 1px rgba(0, 0, 0, .5);
        display: flex;
        position: fixed;
        left: 40px;
        top: 40px;
        bottom: 40px;
        right: 40px;
        background: #FFF;
        z-index: 9999;
        overflow: hidden;
    }

    .app-state-debugger__json {
        white-space: pre; font-family: monospace;
        font-size: 16px;
    }

    .app-state-debugger__block label {
        font-weight: bold;
        width: 100%;
        padding-right: 10px;
    }

    .app-state-debugger__block label, .app-state-debugger__block select {
        font-size: 25px;
    }

    .app-state-debugger__block input {
        width: 30px;
        height: 16px;
    }


    .app-state-debugger__block {
        font-szie: 25px;
        margin-bottom: 30px;
    }

    .app-vignette {
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 50;
    }

    .overflow-auto {
        overflow: auto;
        height: calc(100% - 100px);
    }

</style>



// WEBPACK FOOTER //
// App.vue?d9379da0